import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class GoogleTagManagerService {

	private isLoaded = false;
	private config: GoogleTagManagerConfig = {
		id: environment.googleTagManager.id,
		gtm_auth: environment.googleTagManager.gtmAuth,
		gtm_preview: environment.googleTagManager.gtmPreview,
		gtm_resource_path: environment.googleTagManager.gtmResourcePath
	}

	public addGtmToDom() {
		return new Promise((resolve, reject) => {
			if (this.isLoaded) {
				return resolve(this.isLoaded);
			}
			this.pushOnDataLayer({
				'gtm.start': new Date().getTime(),
				event: 'gtm.js',
			});
			const gtmScript = document.createElement('script');
			gtmScript.id = 'GTMscript';
			gtmScript.async = true;
			gtmScript.src = this.applyGtmQueryParams(this.config.gtm_resource_path
				? this.config.gtm_resource_path
				: 'https://www.googletagmanager.com/gtm.js');
			gtmScript.addEventListener('load', () => {
				return resolve((this.isLoaded = true));
			});
			gtmScript.addEventListener('error', () => {
				return reject(false);
			});
			document.head.insertBefore(gtmScript, document.head.firstChild);
		});
	}

	private getDataLayer() {
		(window as any).dataLayer = (window as any).dataLayer || [];
		return (window as any).dataLayer;
	}

	private pushOnDataLayer(obj) {
		const dataLayer = this.getDataLayer();
		dataLayer.push(obj);
	}


	private applyGtmQueryParams(url) {
		if (url.indexOf('?') === -1) {
			url += '?';
		}
		return (url +
			Object.keys(this.config)
				.filter((k) => this.config[k])
				.map((k) => `${k}=${this.config[k]}`)
				.join('&'));
	}

}

export interface GoogleTagManagerConfig {
	id: string
	gtm_auth: string,
	gtm_preview: string,
	gtm_resource_path: string,
}
